import { motionReduced } from "./motion.js";

// Once a mark's hover loop starts, it plays to the end. If your pointer slips off the link's
// edge and comes back, the mark doesn't snap home or restart. `data-looping` on the link runs
// the loop (site.scss), and the loop's end clears it.
export function loopOnce(link: HTMLElement): void {
  const start = (): void => {
    if (!motionReduced()) link.toggleAttribute("data-looping", true);
  };
  const end = (): void => link.removeAttribute("data-looping");
  link.addEventListener("pointerenter", start);
  link.addEventListener("focus", () => {
    if (link.matches(":focus-visible")) start();
  });
  link.addEventListener("animationend", end);
  link.addEventListener("animationcancel", end);
}
